import { render, staticRenderFns } from "./Locates.vue?vue&type=template&id=1337e0ea"
import script from "./Locates.vue?vue&type=script&lang=js"
export * from "./Locates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports